import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "File Tray Stacked"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-file-tray-stacked',
    templateUrl: './icon-file-tray-stacked.component.html',
    styleUrls: ['./icon-file-tray-stacked.component.scss'],
    standalone: false
})
export class IconFileTrayStackedComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
